import React, { useState } from "react";
import {
  Box,
  Container,
  Typography,
  Button,
  Stack,
  Grid,
  Divider,
} from "@mui/material";
import FormField from "../components//FormField";
import { loginConfig as defaultConfig } from "../config/loginConfig";
import axiosInstance from "../utils/axiosConfig";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
const Login = ({ config = defaultConfig }) => {
  const [role, setRole] = useState("Admin");
  const [formData, setFormData] = useState({});
  const navigate = useNavigate();
  const { login } = useAuth();
  const handleFieldChange = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleSubmit = async (event) => {
    try {
      event.preventDefault();
      const response = await axiosInstance.post(
        `accounts/api/login/`,
        formData,
      );
      const token = response?.data?.token;
      const users = response?.data?.user;
      const role = response?.data?.user?.staff_role?.role_name;
      {
        console.log(users, "lk");
      }
      login({ token, role, users });
      localStorage.setItem("token", response?.data?.token);

      {
        console.log("Logged in user role:", role);
      }
      navigate(
        role === "Admin"
          ? "/worklist/myworklist"
          : role === "carepreneur"
            ? "/worklist/carepreneur"
            : "/",
      );
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  return (
    <Grid container sx={{ minHeight: "100vh" }}>
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          background: "linear-gradient(to bottom right, #DBC4E4,#DBC4E4)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: 4,
        }}
      >
        <Box
          component="img"
          src={require("./images/login-logo.png")}
          alt="Doctors Illustration"
          sx={{ maxWidth: "70%", height: "auto" }}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#fff",
          p: 4,
        }}
      >
        <Container
          maxWidth="xs"
          sx={{
            border: "none",
            boxShadow: "none",
            backgroundColor: "transparent",
          }}
        >
          <Box>
            <Typography
              variant="h5"
              textAlign="center"
              fontWeight="bold"
              gutterBottom
              mb={2}
            >
              {config.sections[0].title}
            </Typography>
            <Box
              sx={{
                display: "flex",
                backgroundColor: "#D1FAF9",
                borderRadius: "30px",
                mb: 3,
                overflow: "hidden",
              }}
            >
              {["Admin", "Doctor"].map((r) => (
                <Button
                  key={r}
                  onClick={() => setRole(r)}
                  sx={{
                    flex: 1,
                    py: 1,
                    backgroundColor: role === r ? "#01B7B3" : "#D0FAF9",
                    color: role === r ? "#fff" : "#000",
                    fontWeight: "bold",
                    textTransform: "none",
                    borderRadius: role === r ? "30px" : 0,
                    "&:hover": {
                      backgroundColor: "#00A5B5",
                      borderRadius: role === r ? "30px" : 0,
                    },
                  }}
                >
                  {r}
                </Button>
              ))}
            </Box>

            {config.sections.map((section) => (
              <Box key={section.title}>
                <form onSubmit={handleSubmit}>
                  <Stack spacing={3}>
                    <Box
                      sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "25px",
                        flexDirection: "column",
                      }}
                    >
                      {section.fields.map((field) => (
                        <Box key={field.name}>
                          <FormField
                            field={field}
                            value={formData[field.name] || ""}
                            onChange={handleFieldChange}
                          />
                        </Box>
                      ))}
                    </Box>

                    <Box textAlign="right">
                      <Typography
                        variant="body2"
                        color="primary"
                        sx={{ cursor: "pointer" }}
                      >
                        Forgot Password?
                      </Typography>
                    </Box>

                    <Button
                      type="submit"
                      fullWidth
                      variant="contained"
                      size="large"
                      sx={{
                        py: 1.5,
                        backgroundColor: "#7C3996",
                        borderRadius: "8px",
                        fontWeight: "bold",
                        "&:hover": { backgroundColor: "#9b59b6" },
                      }}
                    >
                      Login
                    </Button>
                  </Stack>
                </form>
              </Box>
            ))}

            <Box display="flex" alignItems="center" gap={1} mt={3}>
              <Divider
                sx={{ flex: 1, borderBottomWidth: "2px", borderColor: "#ccc" }}
              />
              <Typography variant="body2" color="text.secondary">
                OR
              </Typography>
              <Divider
                sx={{ flex: 1, borderBottomWidth: "2px", borderColor: "#ccc" }}
              />
            </Box>

            <Box textAlign="center" mt={2}>
              <Typography variant="body2">
                Need an account?{" "}
                <Typography
                  component="span"
                  color="primary"
                  sx={{ cursor: "pointer", fontWeight: "bold" }}
                >
                  Sign Up
                </Typography>
              </Typography>
            </Box>
          </Box>
        </Container>
      </Grid>
    </Grid>
  );
};

export { Login };
